
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-grain bg-kadence-darknavy border-t border-white/10 py-8 px-4">
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-center md:text-left flex flex-col items-center md:items-start gap-3">
            <img 
              src="/lovable-uploads/15617071-5299-43b7-b4a6-b8bc014cb2ce.png" 
              alt="Kadence Logo" 
              className="h-8 w-auto opacity-90"
              style={{
                backgroundColor: '#1e2030',
                padding: '4px',
                borderRadius: '4px'
              }}
            />
            <p className="text-gray-300 text-sm">
              © {currentYear} Kadence Talent. All rights reserved.
            </p>
          </div>
          
          <div className="flex flex-wrap justify-center md:justify-end gap-6">
            <a 
              href="https://www.linkedin.com/company/kadencetalent"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-kadence-pink transition-colors text-sm"
            >
              LinkedIn
            </a>
            <Link 
              to="/privacy-policy" 
              className="text-gray-300 hover:text-kadence-pink transition-colors text-sm"
            >
              Privacy Policy
            </Link>
            <Link 
              to="/terms-of-service" 
              className="text-gray-300 hover:text-kadence-pink transition-colors text-sm"
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
